import { ROUTE_PATH, REGION_OPTIONS, STATE_OPTIONS, TEMPLATE_OPTIONS, BRANCH_OPTIONS, BATCH_OPTIONS } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmRadioModel, SmMetaSelectModel, SmMetaFileModel, SmBtnMetaModel, SmMetaTextAreaModel } from "common/models/utility-models/meta-model";
import moment from "moment";




export class StudentsFormMetaModel extends FormMetaModel {
    constructor() {
        super('Add Student', ROUTE_PATH.studentsGrid, ROUTE_PATH.addStudent, 8);
    }
    override initProperties(): any {
        const formInfo = super.initProperties();
        const first_name = new SmMetaInputModel(
            'first_name',
            'first_name',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'First Name',
            'text',
            '[a-zA-Z][a-zA-Z ]+',
            false,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "First name"
        )

        const last_name = new SmMetaInputModel(
            'last_name',
            'last_name',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'Last Name',
            'text',
            '[a-zA-Z][a-zA-Z ]+',
            false,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Last Name"
        )

        const father_name = new SmMetaInputModel(
            'father_name',
            'father_name',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            "Father's Name",
            'text',
            '[a-zA-Z][a-zA-Z ]+',
            false,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Father's Name"
        )

        const mother_name = new SmMetaInputModel(
            'mother_name',
            'mother_name',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            "Mother's Name",
            'text',
            '[a-zA-Z][a-zA-Z ]+',
            false,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Mother's Name"
        )

        const mobile_number = new SmMetaInputModel(
            'mobile_number',
            'mobile_number',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'Mobile Number',
            'number',
            '',
            false,
            true,
            true,
            false,
            10,
            10,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Mobile Number"
        )

        const parentMobileNumber = new SmMetaInputModel(
            'parentMobileNumber',
            'parentMobileNumber',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            "Parent's Mobile Number",
            'number',
            '',
            false,
            true,
            true,
            false,
            10,
            10,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Parent's Mobile Number"
        )

        const email = new SmMetaInputModel(
            'email',
            'email',
            'input',
            true,
            'input-fg form-group col-6 col-md-6',
            2,
            3,
            'Email Id',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            5,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Email Id"
        );

        const gender = new SmRadioModel(

            'gender',
            'gender',
            'radio',
            true,
            'col-xs-12 col-sm-12 col-md-4 col-lg-4 main-gender',
            1,
            2,
            'Gender',
            'checkbox',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            false,
            { evalKey: '', evalParam: [] },
            '',
            2,
            [
                {
                    key: 'male',
                    value: ['off'],
                    label: 'Male',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                },
                {
                    key: 'female',
                    value: ['off'],
                    label: 'Female',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                }
            ]
        );
        const address = new SmMetaInputModel(
            'address',
            'address',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'Residence Address',
            'text',
            '',
            false,
            true,
            true,
            false,
            200,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Residence Address"
        );
        const age = new SmMetaInputModel(
            'age',
            'age',
            'input',
            true,
            'col-12 col-md-4 mt-3',
            1,
            1,
            'Age',
            'number',
            '',
            false,
            true,
            true,
            false,
            2,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Age"
        );
        const region_id = new SmMetaSelectModel(
            'region_id',
            'region_id',
            'ng-select',
            true,
            'col-12 col-md-4 mt-3',
            1,
            8,
            'Region',
            'select',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            REGION_OPTIONS,
            'zone_name',
            'id',

        );
        const state_id = new SmMetaSelectModel(
            'state_id',
            'state_id',
            'select',
            true,
            'col-12 col-md-4 mt-3',
            1,
            8,
            'State',
            'select',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            STATE_OPTIONS,
            'stateName',
            'id',

        );

        const district_id = new SmMetaSelectModel(
            'district_id',
            'district_id',
            'ng-select',
            true,
            'col-12 col-md-4 mt-3',
            1,
            1,
            'District',
            'select',
            'District',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            TEMPLATE_OPTIONS,
            'District',
            'DistrictId'
        );

        const name_of_college = new SmMetaInputModel(
            'name_of_college',
            'name_of_college',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'College Name',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "College Name"
        );
        const college_address = new SmMetaInputModel(
            'college_address',
            'college_address',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'College Address',
            'text',
            '',
            false,
            true,
            true,
            false,
            200,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "College Address"
        );
        const branch_id = new SmMetaSelectModel(
            'branch_id',
            'branch_id',
            'ng-select',
            true,
            'col-12',
            1,
            8,
            'Branch',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            BRANCH_OPTIONS,
            'department_name',
            'id',
            false,
            false,
            false,
            false,
            false,
            false
        );
        const batch_id = new SmMetaSelectModel(
            'batch_id',
            'batch_id',
            'ng-select',
            true,
            'col-12',
            1,
            8,
            'Batch',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            BATCH_OPTIONS,
            'batch_number',
            'id',
            false,
            false,
            false,
            false,
            false,
            false
        );
        const unique_batch_id = new SmMetaInputModel(
            'unique_batch_id',
            'unique_batch_id',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'Unique ID',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Unique ID"
        );
        // const mentor_name = new SmMetaInputModel(
        //     'mentor_name',
        //     'mentor_name',
        //     'input',
        //     false,
        //     'col-6 col-md-6',
        //     1,
        //     1,
        //     'Mentor Name',
        //     'text',
        //     '',
        //     false,
        //     true,
        //     true,
        //     false,
        //     100,
        //     1
        // );
        const mentorId = new SmMetaSelectModel(
            'mentorId',
            'mentorId',
            'select',
            false,
            'col-12 col-md-6 col-lg-6',
            1,
            1,
            'Select Mentor',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'mentorName',
            'id',

        );

        const mentor_email = new SmMetaInputModel(
            'mentor_email',
            'mentor_email',
            'input',
            false,
            'col-12',
            2,
            3,
            'Mentor Email',
            'text',
            '[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}',
            false,
            true,
            true,
            false,
            100,
            5,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Mentor Email"
        );
        const mentor_mobile = new SmMetaInputModel(
            'mentor_mobile',
            'mentor_mobile',
            'input',
            false,
            'col-12',
            1,
            1,
            'Mentor Mobile Number',
            'number',
            '',
            false,
            true,
            true,
            false,
            10,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Mentor Mobile Number"
        
        );

        const remarks = new SmMetaTextAreaModel(
            'remarks',
            'remarks',
            'SimpleTextarea',
            false,
            'col-12 ',
            1,
            2,
            'Mentor Remarks',
            'textarea',
            '',
            false,
            true,
            true,
            false,
            100,
            1,
            false,
            true
        );

        const other = new SmMetaTextAreaModel(
            'other',
            'other',
            'SimpleTextarea',
            false,
            'col-12 ',
            1,
            2,
            'Other Information  (Working on a start up, working with any company,further study details, etc)',
            'textarea',
            '',
            false,
            true,
            true,
            false,
            100,
            1,
            false,
            false
        );

        

        const profile_pic_path = new SmMetaFileModel(
            'profile_pic_path',
            'profile_pic_path',
            'file',
            false,
            'input-fg form-group col-lg-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'profile_pic_path',
            false,
            false,
            2000,
            3000
          );

        const first_year_score = new SmMetaInputModel(
            'first_year_score',
            'first_year_score',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            false,
            true,
            true,
            false,
            7,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "First Semester Score"
            
        );

        const second_year_score = new SmMetaInputModel(
            'second_year_score',
            'second_year_score',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            false,
            true,
            true,
            false,
            7,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Third Semester Score"
            
        );

        const third_year_score = new SmMetaInputModel(
            'third_year_score',
            'third_year_score',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            false,
            true,
            true,
            false,
            7,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Fifth Semester Score"
        );

        const fourth_year_score = new SmMetaInputModel(
            'fourth_year_score',
            'fourth_year_score',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            false,
            true,
            true,
            false,
            7,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Seventh Semester Score"
        );

        const first_year2_score = new SmMetaInputModel(
            'first_year2_score',
            'first_year2_score',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            false,
            true,
            true,
            false,
            7,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Second Semester Score"
        );

        const second_year2_score = new SmMetaInputModel(
            'second_year2_score',
            'second_year2_score',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            false,
            true,
            true,
            false,
            7,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Fourth Semester Score"
        );

        const third_year2_score = new SmMetaInputModel(
            'third_year2_score',
            'third_year2_score',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            false,
            true,
            true,
            false,
            7,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Sixth Semester Score"
        );

        const fourth_year2_score = new SmMetaInputModel(
            'fourth_year2_score',
            'fourth_year2_score',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            false,
            true,
            true,
            false,
            7,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Eighth Semester Score"
        );

        const first_year_credit = new SmMetaInputModel(
            'first_year_credit',
            'first_year_credit',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            false,
            true,
            true,
            false,
            3,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "First Year Score"
            
        );
        const second_year_credit = new SmMetaInputModel(
            'second_year_credit',
            'second_year_credit',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            false,
            true,
            true,
            false,
            3,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Second Year Score"
            
        );
        const third_year_credit = new SmMetaInputModel(
            'third_year_credit',
            'third_year_credit',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            false,
            true,
            true,
            false,
            3,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Third Year Score"
        );
        const fourth_year_credit = new SmMetaInputModel(
            'fourth_year_credit',
            'fourth_year_credit',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            false,
            true,
            true,
            false,
            3,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Fourth Year Score"
        );
        const branchName: string = '';
        // const batch_duration_start: string = '';
        const currentYear: string = moment().format('YYYY');
        const ShowInputs = [
            'first_year_score',
            'second_year_score',
            'third_year_score',
            'fourth_year_score',
            'first_year2_score',
            'second_year2_score',
            'third_year2_score',
            'fourth_year2_score',
            'first_year_credit',
            'second_year_credit',
            'third_year_credit',
            'fourth_year_credit']
        const save = new SmBtnMetaModel('Save', '', true, false, true, false);
        const changeMentor = new SmBtnMetaModel('Change Mentor', 'primary', true, false, true, false);


        return {
            formInfo,
            save,
            first_name,
            last_name,
            father_name,
            mother_name,
            mobile_number,
            parentMobileNumber,
            email,
            gender,
            address,
            age,
            region_id,
            state_id,
            district_id,
            name_of_college,
            college_address,
            branch_id,
            batch_id,
            unique_batch_id,
            mentorId,
            mentor_email,
            mentor_mobile,
            profile_pic_path,
            first_year_score,
            second_year_score,
            third_year_score,
            fourth_year_score,
            first_year2_score,
            second_year2_score,
            third_year2_score,
            fourth_year2_score,
            remarks,
            other,
            // batch_duration_start,
            first_year_credit,
            second_year_credit,
            third_year_credit,
            fourth_year_credit,
            currentYear,
            ShowInputs,
            branchName,
            changeMentor

        }
    }
}